import { UserSession } from "./../../../../../models/usersession";
import { Location } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "src/app/services/alert.service";
import { FarmerService } from "src/app/services/farmer.service";
import { UserSessionService } from "src/app/services/usersession.service";
import { AttachmentType } from "src/enum/attachmentType.enum";
import { FileType } from "src/enum/fileType.enum";
import { RoleType } from "src/enum/roletype";
// import { RoleType } from 'src/enum/roletype';
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { PaccsserviceprovidereditComponent } from "../paccsserviceprovideredit/paccsserviceprovideredit.component";
import { PaccsApprovedStatusType } from "src/enum/paccsapprovedstatustype";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PaccsserviceprovidereditapprovalComponent } from "../paccsserviceprovidereditapproval/paccsserviceprovidereditapproval.component";

@Component({
  selector: "app-toggle-mach-imple",
  templateUrl: "./toggle-mach-imple.component.html",
  styleUrls: ["./toggle-mach-imple.component.scss"],
})
export class ToggleMachImpleComponent implements OnInit {
  selectedTabIndex: any = 0;
  cardArray: any = [];
  mainsession: any;
  farmerbookingList: any[] = [];
  farmerbookingAllList: any[] = [];
  loader: boolean = false;
  dataSource = new MatTableDataSource(this.farmerbookingList);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("searchInput", { static: false }) searchInput: ElementRef;

  @ViewChild('serviceAreaDialog') serviceAreaDialog!: TemplateRef<any>;


  @ViewChild(MatSort, { static: true }) sort: MatSort;
  serviceProviderObj: any;
  imageUrl: any;
  public imageBaseUrl = environment.imageBaseUrl;
  form: any;
  dateWithTime: string;
  fileName: any;
  FileExtention: string;
  BannerImage: File;
  userImageBase64: string;
  attachmentData: any[] = [];
  fileTypeEnum = FileType;
  attachmentType = AttachmentType;
  EsignClicked: boolean;
  userId: any;
  roleId: any;
  canview: boolean;
  pdfSource: any;
  pdfLink: string;
  esignurl: string;
  loading: boolean = false;
  signedFile: any;
  signedType = 0;
  esignLink: string;
  parameter1: string | any;
  parameter2: string | any;
  parameter3: string | any;
  ShowDriverDetails: boolean = false;
  selectedDriverDetail: any;
  currentItemsToShow: any[];

  list: any[] = [];
  column: string = '';

  public RoleType = RoleType;
  public PaccsApprovedStatusType = PaccsApprovedStatusType
  OwnerName: any;
  Vehicle: any;
  isMarkAsDuplicate: boolean = false;
  isSubmitEnabled: boolean = false;
  constructor(
    private farmerService: FarmerService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private userservicesession: UserSessionService,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService,
    private dialog: MatDialog,
    public modalService: NgbModal,
  ) {
    this.userId = this.userservicesession.userId();
    this.roleId = this.userservicesession.roleId();
    if (this.roleId == RoleType.AssistantExecutiveEngineer) {
      this.canview = true;
    } else {
      this.canview = false;
    }
    this.esignurl = environment.esignUrl;
    let mainsession = localStorage.getItem("serviceProviderDetails");
    if (!mainsession) {
      this.location.back();
    }
    this.mainsession = JSON.parse(mainsession);
    if (
      this.mainsession.isSPEsigned &&
      !this.mainsession.isAEEEsigned &&
      this.roleId == RoleType.AssistantExecutiveEngineer
    ) {
      this.GenerateXml();
    }
  }

  ngOnInit() {
    this.onTabChange({ target: { value: 2 } });

    this.route.queryParams.subscribe((params) => {
      this.signedFile = params["signed_file"];
      if (this.signedFile != "" && this.signedFile != undefined) {
        if (this.signedFile != "failed") {
          this.signedType = 1;
          this.esignLink = environment.imageBaseUrl + "AeeEsign/" + this.signedFile;
          // this.EsignUpdate(this.signedFile);
          this.alertService.success("eSign has been Updated Successfully");
          this.router.navigate(["serviceprovider"]);
        } else {
          this.signedType = 2;
          Swal.fire(
            "Error",
            "Failed to Esign, Please try again later.",
            "error"
          );
        }
      }
    });
}

  EsignUpdate(esignLink: any) {
    const payload = {
      serviceProviderId: this.mainsession?.id,
      imagePath: esignLink,
    };

    this.farmerService.updateesign(payload).subscribe(
      (res: any) => {
        if (res && res.isSuccess) {
          this.alertService.success("eSign has been Updated Successfully");
          this.router.navigate(["serviceprovider"]);
        } else {
          this.alertService.error(res.htmlFormattedFailures);
        }
      },
      (error) => {
        Swal.fire("Error", "Failed to submit data.", "error");
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.paginator = this.paginator;
    this.cardArray = this.dataSource.filteredData;
    this.onPageChange({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 10,
      length: this.cardArray.length,
    });
  }
  downloadReceipt() {
    let data = {
      phireReportType: 3,
      downloadType: 1,
      bookingId: 0,
      userId: this.mainsession.id,
      languageType: 1,
    };
    this.farmerService
      .downloadPhireReceiptdownload(data)
      .subscribe((result) => {
        if (result) {
          this.pdfSource = result.fileName;
          this.pdfLink = environment.imageBaseUrl + "Receipt/" + this.pdfSource;
          const downloadLink = document.createElement("a");
          const fileName = "payment.pdf";
          downloadLink.href = this.pdfLink;
          downloadLink.download = fileName;
          downloadLink.target = "_blank";
          downloadLink.click();
        }
      });
  }
  downloadDGCA() {
    const imageUrl =
      this.imageBaseUrl + this.selectedDriverDetail.dgcaCertificateImagePath;

    // Fetch the image as a blob
    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "DGCA-Certificate.jpg"; // Set desired filename
        link.click();
        window.URL.revokeObjectURL(blobUrl); // Clean up
      })
      .catch((err) => {
        console.error("Download failed:", err);
      });
  }

  downloadLicence() {
    const imageUrl =
      this.imageBaseUrl + this.selectedDriverDetail.licenseImagePath;

    // Fetch the image as a blob
    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "License.pdf"; // Set desired filename
        link.click();
        window.URL.revokeObjectURL(blobUrl); // Clean up
      })
      .catch((err) => {
        console.error("Download failed:", err);
      });
  }

  downloadImage(id: any) {
    if (id) {
      if (id == 1) {
        this.imageUrl =
          this.imageBaseUrl + this.serviceProviderObj?.aadharImagePath;
      } else if (id == 2) {
        this.imageUrl =
          this.imageBaseUrl + this.serviceProviderObj?.panImagePath;
      } else {
        this.imageUrl =
          this.imageBaseUrl + this.serviceProviderObj?.bankPassBookImagePath;
      }
      var url = this.imageUrl;
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          if (id == 1) {
            downloadLink.download = "Aadhar";
          } else if (id == 2) {
            downloadLink.download = "Pan";
          } else {
            downloadLink.download = "PassBook";
          }
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(blobUrl);
        })
        .catch((error) => {
          console.error("Error downloading the document:", error);
        });
    }
  }
  ngAfterViewInit() {
    this.onTabChange({ target: { value: this.selectedTabIndex || 0 } });
  }

  download() {
    const imageUrl =
      this.imageBaseUrl + this.selectedDriverDetail.dgcaCertificateImagePath;

    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = "license-image.jpg"; // You can set a dynamic name if needed
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onTabChange(event: any) {
    this.selectedTabIndex = parseInt(event.target.value);
    this.loader = true;
    this.ShowDriverDetails = false;
    if (this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.value = "";
    }
    if (this.selectedTabIndex === 0) {
      this.farmerService
        .GetVehicleByUser(this.mainsession.id)
        .subscribe((res) => {
          this.setData(res);
        });
    } else {
      if (this.selectedTabIndex === 1) {
        this.farmerService
          .GetImplementByUser(this.mainsession.id)
          .subscribe((res) => {
            this.setData(res);
          });
      } else if (this.selectedTabIndex === 2) {
        // this.serviceProviderObj = this.mainsession;
        // this.loader = false;
        // console.log("rpovidedetails:", this.mainsession);
        this.farmerService
          .GetInformationByUser(this.mainsession.id)
          .subscribe((res) => {
            this.serviceProviderObj = res;
            this.loader = false;
          });
      } else if (this.selectedTabIndex === 3) {
        this.farmerService
          .GetInformationforDriver(this.mainsession.id)
          .subscribe((res) => {
            this.setData(res);
            this.loader = false;
          });
      } else if (this.selectedTabIndex === 4) {
        this.farmerService
          .GetInformationforTariff(this.mainsession.id)
          .subscribe((res) => {
            this.setData(res);
            // this.serviceProviderObj = [
            //   {
            //     "vehicleId": 1,
            //     "vehicleCategoryName": "Tractor",
            //     "vehicleRegNo": "MH12AB1234",
            //     "vehicleOwnerName": "Ramesh Pawar",
            //     "vehicleMake": "Mahindra",
            //     "vehicleModel": "575 DI",
            //     "vehicleEngineNo": "ENG1234567890",
            //     "vehicleChassisNo": "CHS0987654321",
            //     "implementCategoryName": "Plough",
            //     "implementMake": "John Deere",
            //     "implementModel": "Model-X",
            //     "amount": 450000000,
            //     "nonWorkingDays": "Sunday, National Holidays"
            //   },
            //   {
            //     "vehicleId": 2,
            //     "vehicleCategoryName": "Harvester",
            //     "vehicleRegNo": "KA03MN5678",
            //     "vehicleOwnerName": "Suresh Naik",
            //     "vehicleMake": "Swaraj",
            //     "vehicleModel": "735 FE",
            //     "vehicleEngineNo": "ENG2345678910",
            //     "vehicleChassisNo": "CHS1234567890",
            //     "implementCategoryName": "Seeder",
            //     "implementMake": "Kubota",
            //     "implementModel": "SDS-20",
            //     "amount": 55000,
            //     "nonWorkingDays": "Saturday"
            //   }
            // ]

            this.loader = false;
          });
      }
    }
  }

  viewDriver(item: any) {
    this.farmerService.GetfullInformationforDriver(item.id).subscribe((res) => {
      this.selectedDriverDetail = res;
      this.ShowDriverDetails = true;
    });
  }

  setData(res: any) {
    this.cardArray = [];
    this.farmerbookingList = [];
    this.farmerbookingAllList = [];
    // this.searchInput.nativeElement.value = '';
    if (res) {
      this.farmerbookingList = res;
      this.farmerbookingAllList = res;
      this.dataSource = new MatTableDataSource(this.farmerbookingList);
      this.cardArray = this.farmerbookingList;
      this.dataSource.paginator = this.paginator;
      this.onPageChange({
        previousPageIndex: 0,
        pageIndex: 0,
        pageSize: 10,
        length: this.farmerbookingList.length,
      });
    }
    this.loader = false;
  }

  onPageChange($event) {
    this.cardArray = this.dataSource.filteredData.slice(
      $event.pageIndex * $event.pageSize,
      $event.pageIndex * $event.pageSize + $event.pageSize
    );
  }

  dataFilter(event: any) {
    if (this.selectedTabIndex === 0) {
      this.cardArray = this.farmerbookingAllList.filter(
        (i) =>
          i.regNo
            .trim()
            .toLowerCase()
            .includes(event.value.trim().toLowerCase()) ||
          i.vehicleCategoryName
            .trim()
            .toLowerCase()
            .includes(event.value.trim().toLowerCase()) ||
          i.registrationTs
            .trim()
            .toLowerCase()
            .includes(event.value.trim().toLowerCase()) ||
          i.insuranceExpiryTs
            .trim()
            .toLowerCase()
            .includes(event.value.trim().toLowerCase())
      );
    } else {
      this.cardArray = this.farmerbookingAllList.filter(
        (i) =>
          i.implementName
            .trim()
            .toLowerCase()
            .includes(event.value.trim().toLowerCase()) ||
          i.type
            .trim()
            .toLowerCase()
            .includes(event.value.trim().toLowerCase()) ||
          i.purchasedOn
            .trim()
            .toLowerCase()
            .includes(event.value.trim().toLowerCase())
      );
    }
  }

  viewMachine(data) {
    localStorage.setItem("machineryDetails", JSON.stringify(data));
    this.router.navigate(["pvtmachinery/view"]);
  }

  viewImplement(data) {
    localStorage.setItem("implementDetails", JSON.stringify(data));
    this.router.navigate(["pvtimplement/view"]);
  }
  onCancel() {
    const backRoute = localStorage.getItem('backRoute');
  
  if (backRoute == '1') {
    localStorage.removeItem('backRoute');
    this.router.navigate(['/paccsduplicate']); 
  } else {
    if (this.serviceProviderObj?.serviceProviderType == 2) {
      this.router.navigate(["paccsserviceprovider"]);
    } else {
      this.router.navigate(["serviceprovider"]);
    }
    // this.location.back();
  }
  }

  donwloadImageFromPath(ImagePath) {
    let src = environment.imageBaseUrl + ImagePath;
    window.open(encodeURI(src));
    const downloadLink = document.createElement("a");
    const fileName = ImagePath;
    downloadLink.href = src;
    downloadLink.download = fileName;
  }

  goesign() {
    this.loading = true;
    // this.esignurl = environment.esignUrl + 'epermit_req.php?rtype=2&fname=' + this.mainsession?.serviceProviderEsignImagePath;
    // window.location.href = this.esignurl;
  }

  GenerateXml() {
    let req = {
      imagePath: this.mainsession?.serviceProviderEsignImagePath,
      userId: this.mainsession?.id,
    };
    this.farmerService.generateXml(req).subscribe((response) => {
      if (response && response.value && response.isSuccess) {
        this.parameter1 = response.value.parameter1;
        this.parameter2 = response.value.parameter2;
        this.parameter3 = response.value.parameter3;
      } else {
        Swal.fire("Error", "Failed to Esign, Please try again later.", "error");
      }
    });
  }

  EsignClick() {
    this.EsignClicked = !this.EsignClicked;

    const Yes = "சமர்ப்பிக்கவும்";

    const htmlContent = `
        <div>
  <label>
    <input type="checkbox" id="esignCheckbox" style="margin-right: 10px; margin-top: 10px">
    I have read and fully accept all the terms and conditions in the agreement copy
  </label>
</div>
<div class="col-md-12 mt-3">
  <label class="ml-1 font-weight-bold mandatory label-form">
    Upload the signed agreement copy
    <small>(File Type:pdf File Size: Up to 10 MB)</small>
  </label>
  <div class="pic-back" style="overflow: hidden;">
    <div class="photo-upload">
      <input id="imageName" type="file" accept=".png,.jpg,.jpeg,.pdf" style="display: none" />
      <div class="cloud-icon">

        <button id="uploadButton" class="btn upload-button" type="button">
        <img class="img-cloud" width="70px" src="../../../../../../assets/images/cloud-icon.png" alt="photo-upload"><br><br>
          Upload
        </button>
      </div>
      <div id="fileUploadContainer"></div>
    </div>
  </div>
</div>
      `;

    Swal.fire({
      html: htmlContent,
      // icon: 'warning',
      showCancelButton: false,
      confirmButtonText: "Yes",
      preConfirm: () => {
        const isChecked = (
          document.getElementById("esignCheckbox") as HTMLInputElement
        )?.checked;
        if (!isChecked) {
          Swal.showValidationMessage("Please check the checkbox");
          return false;
        }
        return true;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const fileInput = document.getElementById(
          "imageName"
        ) as HTMLInputElement;
        if (!fileInput.files?.length) {
          Swal.fire("Error", "Please upload a file.", "error");
          return;
        }

        const file = fileInput.files[0];
        if (file.type !== "application/pdf") {
          Swal.fire("Error", "Only PDF files are allowed.", "error");
          return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result as string;
          // Prepare payload
          const payload = {
            userId: this.serviceProviderObj.id,
            attachment: {
              id: 0,
              attachmentFilename: this.fileName,
              attachmentType: this.attachmentType.AeeEsign,
              base64String: base64Data.split(",")[1],
            },
          };

          this.farmerService.setIsigned(payload).subscribe(
            (res: any) => {
              if (res.isSuccess) {
                this.location.back();
              }
            },
            (error) => {
              Swal.fire("Error", "Failed to submit data.", "error");
            }
          );
        };
        reader.readAsDataURL(file);
      }
    });

    setTimeout(() => {
      const uploadButton = document.getElementById("uploadButton");
      const fileInput = document.getElementById(
        "imageName"
      ) as HTMLInputElement;
      const fileUploadContainer = document.getElementById(
        "fileUploadContainer"
      );

      uploadButton?.addEventListener("click", () => fileInput?.click());
      fileInput?.addEventListener("change", () => {
        if (fileInput.files?.length) {
          this.fileName = fileInput.files[0].name;

          if (fileUploadContainer) {
            fileUploadContainer.innerHTML = `
      <div class="uploaded-file-info">
        <p>Uploaded File: <strong>${this.fileName}</strong></p>
      </div>
    `;
          }
        }
      });
    }, 0);
  }
  verify() {
    const title = this.translate.instant("Verify Confirmation");
    const Yes = this.translate.instant("Verify");
    const No = this.translate.instant("Cancel");
    Swal.fire({
      title: title,
      text: "Do you want to Verify Bank Details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((res) => {
      if (res.value) {
        var data = {
          id: this.serviceProviderObj.bankDetail.id,
        };
        this.farmerService.verifyOrNot(data).subscribe((res) => {
          if (res && res.isSuccess) {
            this.alertService.success("Bank Details Verified Successfully.");
            this.onCancel();
            this.onTabChange({ target: { value: 2 } });
          } else {
            this.alertService.error(res.htmlFormattedFailures);
          }
        });
      }
    });
  }

  // Paccs ServiceProviderEdit
  paccsServiceProviderEdit() {
    const editData = {
      id: this.serviceProviderObj.id,
      name: this.serviceProviderObj.name,
      paccsType: this.serviceProviderObj.paccsType,
      paccsTypeName: this.serviceProviderObj.paccsTypeName,
      ePaccsRefNo: this.serviceProviderObj.ePaccsRefNo,
      secretaryName: this.serviceProviderObj.secretaryName,
      genderType: this.serviceProviderObj.genderType,
      mobileNo: this.serviceProviderObj.mobileNo,
      panNo: this.serviceProviderObj.panNo,
      attachment: this.serviceProviderObj.panImagePath,
      address: this.serviceProviderObj.address,
      districtId: this.serviceProviderObj.districtId,
      talukId: this.serviceProviderObj.talukId,
      blockId: this.serviceProviderObj.blockId,
      gramPanchayatId: this.serviceProviderObj.gramPanchayatId,
      pinCode: this.serviceProviderObj.pinCode,
      bankName: this.serviceProviderObj.bankDetail.bankName,
      accountNumber: this.serviceProviderObj.bankDetail.accountNumber,
      branchName: this.serviceProviderObj.bankDetail.branchName,
      ifscCode: this.serviceProviderObj.bankDetail.ifscCode,
      cityName: this.serviceProviderObj.bankDetail.cityName,
      bankPassBookImagePath: this.serviceProviderObj.bankPassBookImagePath,
      isAccountVerified: this.serviceProviderObj.bankDetail.isAccountVerified,
    }
    const dialogRef = this.dialog.open(PaccsserviceprovidereditComponent, {
      width: '100%',
      height: '90%',
      disableClose: true,
      data: { data: editData }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result.isClosed) {
        return;
      } else if (result.isSuccess) {
        this.onTabChange({ target: { value: 2 } });
        this.alertService.success('Service provider details have been updated successfully')
      } else {
        this.alertService.error(result.htmlFormattedFailures)
      }
    });
  }


  paccsServiceProviderEditafterApproval() {
    const editsData = {
      id: this.serviceProviderObj.id,
      paccsType: this.serviceProviderObj.paccsType,
      paccsTypeName: this.serviceProviderObj.paccsTypeName,
      ePaccsRefNo: this.serviceProviderObj.ePaccsRefNo,
      secretaryName: this.serviceProviderObj.secretaryName,
      genderType: this.serviceProviderObj.genderType,
      mobileNo: this.serviceProviderObj.mobileNo,
      aadharNo: this.serviceProviderObj.aadharNo,
      attachment: this.serviceProviderObj.aadharImagePath,
      userImagePath: this.serviceProviderObj.userImagePath,
    }
    const dialogRef = this.dialog.open(PaccsserviceprovidereditapprovalComponent, {
      width: '100%',
      height: '90%',
      disableClose: true,
      data: { data: editsData }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result.isClosed) {
        return;
      } else if (result.isSuccess) {
        this.onTabChange({ target: { value: 2 } });
        this.alertService.success('Service provider details have been updated successfully')
      } else {
        this.alertService.error(result.htmlFormattedFailures)
      }
    });
  }

  // Service Provider Approve
  serviceProviderApprove(data: any) {
    const payload = {
      PaccsId: data.id,
      PaccsApprovedStatusType: this.PaccsApprovedStatusType.Approved
    }
    Swal.fire({
      title: 'Conformation',
      html: `<h5>Are you sure you want to approve this PACCS request?</h5>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        this.farmerService.paccsServiceProviderApprove(payload).subscribe((result) => {
          if (result.isSuccess) {
            this.alertService.success('The Paccs has been approved successfully')
            this.router.navigate(['/paccsserviceprovider'])
          } else {
            this.alertService.error(result.htmlFormattedFailures)
          }
        })
      } else {
        return;
      }
    });
  }

  // MachineAddress(item: any) {
  //   const list = item?.availabilityInfoList || [];
  //   const column = item?.serviceProviderType == 1 ? 'Taluk' : 'Block'

  //   const htmlContent = `
  //     <div style="text-align:left;">
  //       <table style="width:100%; border-collapse:collapse; font-size:14px;">
  //         <thead>
  //           <tr style="background:#005f73; color:#fff;">
  //             <th style="padding:8px 12px; text-align:left;">District</th>
  //             <th style="padding:8px 12px; text-align:left;">${column}</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           ${list.map((x: any, i: number) => `
  //             <tr style="background:${i % 2 === 0 ? '#f9f9f9' : '#fff'};">
  //               <td style="padding:7px 12px; color:#333;">${x.district}</td>
  //               <td style="padding:7px 12px; color:#333;">${x.blockorTaluk}</td>
  //             </tr>
  //           `).join('')}
  //         </tbody>
  //       </table>

  //     </div>
  //   `;

  //   Swal.fire({
  //     title: 'Service Area',
  //     html: htmlContent,
  //     showCloseButton: true,
  //     showConfirmButton: false,
  //     width: '450px',
  //     customClass: {
  //       title: 'swal-title-top',
  //       closeButton: 'swal-close-big'
  //     }
  //   });
  // }
  MachineAddress(item: any) {
    this.list = item?.availabilityInfoList || [];
    this.column = item?.serviceProviderType == 1 ? 'Taluk' : 'Block';

    this.OwnerName = item?.ownerName;
    this.Vehicle = item?.vehicleCategoryName || item?.implementName;

    this.modalService.open(this.serviceAreaDialog, {
      centered: true,
      windowClass: 'modal-custom'
    });
  }

  onDuplicateChange(event: any) {
    if (event.target.checked) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to mark this record as duplicate?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.isMarkAsDuplicate = true;
          this.isSubmitEnabled = true;
        } else {
          this.isMarkAsDuplicate = false;
          this.isSubmitEnabled = false;
          event.target.checked = false;
        }
      });
    } else {
      this.isSubmitEnabled = false;
    }
  }

  markAsDuplicateSubmit() {
    if (this.isMarkAsDuplicate) {
      this.farmerService.paccsMarkAsDuplicate(this.mainsession?.id).subscribe((res: any) => {
        if (res && res.isSuccess) {
          this.alertService.success("Marked as Duplicate Successfully");
          this.router.navigate(["paccsserviceprovider"]);
        } else {
          this.alertService.error(res.htmlFormattedFailures);
        }
      }, error => {
        Swal.fire("Error", "Failed to mark as duplicate.", "error");
      });
    }
  }
}
